import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const DisplayElementsMappedCount = ({ BLOCK, count }) => {
  return (
    <div className={`${BLOCK}__mapped-elements-count`}>
      <FormattedMessage
        id="side-by-side-view.mapped.element.count.label"
        values={{ count: count }}
      />
    </div>
  );
};

DisplayElementsMappedCount.propTypes = {
  /** BEM block name for CSS class naming */
  BLOCK: PropTypes.string.isRequired,
  /** Number of mapped elements */
  count: PropTypes.number,
};

export default DisplayElementsMappedCount;
